module.exports = __webpack_public_path__ + "img/qyjscxxm_bd.3fb466d.png";